import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './icon.module.scss';

import gettingStarted from './img/2xicn_getting_started.png';
import collaborating from './img/2xicn_collaborating.png';
import managing from './img/2xicn_project_planning_level_1.png';
import reporting from './img/2xicn-project-planning-level-II.png';
import topVideos from './img/2xicn_top_videos.png';
import tips from './img/icn-tips@2x.png';
import accounts from './img/icn-account@2x.png';
import time from './img/icn-time-tracking@2x.png';
import integrations from './img/icn-integrations@2x.png';
import viewOptions from './img/icn-project-view-options@2x.png';

const iconMap = {
  '5511aff4e4b061031401fb4c': {
    src: gettingStarted,
    bg: '#B1B9CD',
  },
  '5f510e62c9e77c0016384617': {
    src: viewOptions,
    bg: '#01AAFF',
  },
  '5284de2fe4b027e0d843bc97': {
    src: collaborating,
    bg: '#33C68C',
  },
  '526eaf43e4b06c89ec332a52': {
    src: managing,
    bg: '#B970D7',
  },
  '5afb35e42c7d3a640ed6de95': {
    src: reporting,
    bg: '#FF8063',
  },
  '5284df24e4b027e0d843bca8': {
    src: tips,
    bg: '#F3BD52',
    portrait: true,
  },
  '57e9e78d9033602e61d4835c': {
    src: accounts,
    bg: '#7FD1CD',
  },
  videos: {
    src: topVideos,
    bg: '#FDA0A9',
  },
  '5284dea7e4b04fbdf2ac3a02': {
    src: time,
    bg: '#A9CF43',
    portrait: true,
  },
  '528a6bcee4b0bb9de0e9a1f6': {
    src: integrations,
    bg: '#5CBCD6',
    portrait: true,
  },
};

const DEFAULT_ICON = {
  src: 'https://placekitten.com/200/200',
  bg: '#efefef',
};

function getIcon({id}) {
  if (iconMap[id]) {
    return {...DEFAULT_ICON, ...iconMap[id]};
  }
  return DEFAULT_ICON;
}

const Icon = ({category}) => {
  const {bg, src, portrait} = getIcon(category);
  return (
    <div
      className={classNames('card-image', styles.Icon)}
      style={{backgroundColor: bg}}
    >
      <img
        className={classNames(styles.Icon__img, {
          [styles['Icon__img--portrait']]: portrait,
        })}
        src={src}
      />
    </div>
  );
};

Icon.propTypes = {
  category: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
};

export default Icon;



// WEBPACK FOOTER //
// ./src/components/topics/Icon.js